import styled from 'styled-components';
import clock from '~/assets/icons/clock.svg';
import { Text } from '~/components/ui/Text';

const StyledModalBody = styled.div`
	display: flex;
	flex-direction: column;
	row-gap: 30px;
`;

const StyledButtonsContainer = styled.div`
	display: grid;
	grid-template-columns: 1fr 1fr;
	column-gap: 20px;
`;

const StyledRow = styled.div`
	display: flex;
	align-items: center;
	justify-content: space-between;
`;

const StyledPrice = styled.div`
	display: flex;
	align-items: center;
	gap: 10px;
	user-select: none;
	pointer-events: none;

	& > ${Text} {
		font-weight: 700;
		font-size: 18px;
		color: #ffffff;
	}
`;

const StyledTime = styled.div`
	display: flex;
	align-items: center;
	gap: 10px;
	user-select: none;
	pointer-events: none;

	& > ${Text} {
		font-weight: 500;
		font-size: 18px;
		color: #ffffff;
	}
`;

const StyledClockIcon = styled.div`
	width: 16px;
	height: 16px;

	mask-position: center;
	mask-repeat: no-repeat;
	mask-image: url(${clock});
	-webkit-mask-position: center;
	-webkit-mask-repeat: no-repeat;
	-webkit-mask-image: url(${clock});
	background-color: #ffbf42;
`;

export {
	StyledButtonsContainer,
	StyledClockIcon,
	StyledModalBody,
	StyledPrice,
	StyledRow,
	StyledTime,
};
